import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../Assets/logo.png';

export default function RegisterName() {
  const [name, setName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cellphone = localStorage.getItem("cellphone");
    const clientId = localStorage.getItem("client_id");

    if (!cellphone || !clientId) {
      navigate("/");
      return;
    }
    
    setErrorMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_APP_URL}/client/${clientId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      });

      if (!response.ok) {
        throw new Error("Erro ao atualizar nome.");
      }

      localStorage.setItem("client_name", name);
      navigate("/processing-status");
    } catch (err) {
      setErrorMessage('Erro ao salvar nome. Tente novamente.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-purple via-brand-purple-light to-brand-teal flex flex-col items-center justify-center px-6 py-8">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20" style={{backgroundImage: "url('data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.05%27%3E%3Ccircle cx=%2730%27 cy=%2730%27 r=%272%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"}}></div>
      
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-sm">
        {/* Logo Container */}
        <div className="text-center mb-8">
          <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-6 shadow-2xl mb-6">
            <img src={logo} alt="VisageAI logo" className="block max-w-[160px] w-full h-auto mx-auto" />
          </div>
        </div>

        {/* Form Container */}
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-6 shadow-2xl">
          <div className="text-center mb-8">
            <div className="bg-gradient-to-r from-brand-purple to-brand-purple-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h2 className="text-brand-purple text-xl font-semibold mb-2">Prazer em conhecê-lo!</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Como você gostaria de ser chamado durante<br />
              sua experiência no VisageAI?
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2">Seu nome</label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Ex: Maria, João..."
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full border-2 border-gray-200 rounded-2xl py-4 px-4 text-base bg-white shadow-sm focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/20 outline-none transition-all duration-300 placeholder-gray-400 focus:placeholder-gray-300"
                />
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Error Message */}
            {errorMessage && (
              <div className="mb-4 p-3 bg-red-50 rounded-xl border border-red-200">
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                  <p className="text-red-800 text-sm font-medium">{errorMessage}</p>
                </div>
              </div>
            )}
            
            <button 
              type="submit" 
              disabled={!name.trim()}
              className={`w-full border-none rounded-2xl py-4 px-6 font-semibold text-base transition-all duration-300 transform shadow-lg ${
                name.trim()
                  ? 'bg-gradient-to-r from-brand-teal to-brand-teal-dark hover:from-brand-teal-dark hover:to-brand-teal text-white hover:scale-[1.02] active:scale-[0.98] hover:shadow-xl'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                Vamos começar!
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1.01M15 10h1.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
            </button>
          </form>
          
          {/* Welcome Message */}
          <div className="text-center mt-6 pt-4 border-t border-gray-100">
            <div className="flex items-center justify-center gap-2">
              <svg className="w-4 h-4 text-brand-teal" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
              </svg>
              <span className="text-xs text-gray-500">Estamos ansiosos para te ajudar!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
